module.exports = __webpack_public_path__ + "img/paypal-express.d79d0328.png";